import { type SupportBlocking, type SupportCategory } from '@onr/schema'
import { create } from 'zustand'

export type SupportPanelView = { kind: 'requests' } | { kind: 'new' } | { kind: 'conversation'; number: number }

export interface SupportRequestDraft {
  category: SupportCategory | null
  blocking: SupportBlocking | null
  text: string
}

export interface SupportPageContext {
  detail: string | null
  object: { label: string; url: string } | null
}

interface SupportPanelState {
  open: boolean
  view: SupportPanelView
  draft: SupportRequestDraft
  pageContext: SupportPageContext
  openPanel: () => void
  closePanel: () => void
  showRequests: () => void
  showNewRequest: () => void
  showConversation: (number: number) => void
  updateDraft: (draft: Partial<SupportRequestDraft>) => void
  discardDraft: () => void
  setPageContext: (pageContext: SupportPageContext) => void
}

export const EMPTY_SUPPORT_DRAFT: SupportRequestDraft = { category: null, blocking: null, text: '' }

export const useSupportPanelStore = create<SupportPanelState>()((set) => ({
  open: false,
  view: { kind: 'requests' },
  draft: EMPTY_SUPPORT_DRAFT,
  pageContext: { detail: null, object: null },
  openPanel: () => set(({ view }) => ({ open: true, view: view.kind === 'new' ? view : { kind: 'requests' } })),
  closePanel: () => set({ open: false }),
  showRequests: () => set({ view: { kind: 'requests' } }),
  showNewRequest: () => set({ view: { kind: 'new' } }),
  showConversation: (number) => set({ view: { kind: 'conversation', number } }),
  updateDraft: (draft) => set((state) => ({ draft: { ...state.draft, ...draft } })),
  discardDraft: () => set({ draft: EMPTY_SUPPORT_DRAFT, view: { kind: 'requests' } }),
  setPageContext: (pageContext) => set({ pageContext }),
}))
